import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'
import { EntityId } from '@reduxjs/toolkit'
import { playlistExtraReducers } from '@store/reducres/playlist.reducers'

export const playlistUrl = 'playlist/'

export interface PlaylistModel extends DjangoModel {
  time?: Date | null
  version: string
  databaseVersion: string
  databaseName: string
  databaseServer: string
  stationId: string
  fromTime: string
  toTime: string
  result: string
  aiSlots: EntityId[] // IDs of slot items
  items: string
  playlistState: number
  defaultVoice: EntityId
}

const {
  slice: playlistSlice,
  adapter: playlistAdapter,
  thunks: playlistThunks,
  selectors,
  actions,
} = createGenericSlice<PlaylistModel>(
  'playlist',
  playlistUrl,
  {},
  playlistExtraReducers
)

export const PlaylistAdapterExport = playlistAdapter

export const { fetchById: fetchPlaylistById, fetchAll: fetchAllPlaylists } =
  playlistThunks

export const { selectAll: selectAllPlaylists, selectById: selectPlaylistById } =
  playlistAdapter.getSelectors<RootState>((state: RootState) => state.playlist)

export const {
  selectLoading: selectPlaylistLoading,
  selectIsIdInProgress: selectIsPlaylistIdInProgress,
  selectError: selectPlaylistError,
  selectByIds: selectPlaylistByIds,
} = selectors

export const {
  setInProgress: setPlaylistInProgress,
  setProgressFinished: setPlaylistProgressFinished,
} = actions

export default playlistSlice.reducer
